<template>
  <div class="animated fadeIn">
    <loader
     :show="formulario.enviando"/>
    <b-row>
      <b-col sm="12" md="12">
        <b-card header-tag="header" >
          <div slot="header">
            <strong> {{ titulo }} </strong>
          </div>
          <b-form  @submit.prevent="agregarUsuario">
            <b-row>
                
                <!-- C O D I G O -->
                <b-col md="4" sm="6">
                  <b-form-group id="grupoCodigo"
                      label="Codigo:"
                      label-for="codigoInput"
                    >
                    <b-form-input id="codigoInput"
                      type="text"
                      v-model.trim="formulario.codigo"
                      placeholder="Ingrese código..."
                      :class="{invalid_input: $v.formulario.codigo.$error}"
                      >
                    </b-form-input>
                    <label v-if="$v.formulario.codigo.$error && !$v.formulario.codigo.required" 
                        id="name-error" class="error" for="ac_codigo">
                        <i>Campo requerido.</i></label>
                    <label v-if="$v.formulario.codigo.$error && !$v.formulario.codigo.minLength" 
                        id="name-error" class="error" for="ac_codigo">
                        <i>Debe tener mínimo 4 caracteres.</i></label>
                  </b-form-group>
                </b-col>

                <!--  N O M B R E   -->
                <b-col md="4" sm="6">
                  <b-form-group id="grupoNombre"
                      label="Nombre:"
                      label-for="nombreInput"
                    >
                    <b-form-input id="nombreInput"
                      type="text"
                      v-model.trim="formulario.nombre"
                      placeholder="Ingrese nombre..."
                      :class="{invalid_input: $v.formulario.nombre.$error}"
                      >
                    </b-form-input>
                    <label v-if="$v.formulario.nombre.$error && !$v.formulario.nombre.required" 
                        id="name-error" class="error" for="ac_nombre">
                        <i>Campo requerido.</i></label>
                    <label v-if="$v.formulario.nombre.$error && !$v.formulario.nombre.minLength" 
                        id="name-error" class="error" for="ac_nombre">
                        <i>Debe tener mínimo 2 caracteres.</i></label>
                  </b-form-group>
                </b-col>

                <!--  P A T E R N O   -->
                <b-col md="4" sm="6">
                  <b-form-group id="grupoPaterno"
                      label="Paterno:"
                      label-for="paternoInput"
                    >
                    <b-form-input id="paternoInput"
                      type="text"
                      v-model.trim="formulario.paterno"
                      placeholder="Ingrese paterno..."
                      :class="{invalid_input: $v.formulario.paterno.$error}"
                      >
                    </b-form-input>
                    <label v-if="$v.formulario.paterno.$error && !$v.formulario.paterno.required" 
                        id="name-error" class="error" for="ac_paterno">
                        <i>Campo requerido.</i></label>
                  </b-form-group>
                </b-col>

                <!--  M A T E R N O   -->
                <b-col md="4" sm="6">
                  <b-form-group id="grupoMaterno"
                      label="Materno:"
                      label-for="maternoInput"
                    >
                    <b-form-input id="maternoInput"
                      type="text"
                      v-model.trim="formulario.materno"
                      placeholder="Ingrese materno..."
                      :class="{invalid_input: $v.formulario.materno.$error}"
                      >
                    </b-form-input>
                    <label v-if="$v.formulario.materno.$error && !$v.formulario.materno.required" 
                        id="name-error" class="error" for="ac_materno">
                        <i>Campo requerido.</i></label>
                  </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="2">
                <b-button 
                    size="sm" 
                    variant="primary"
                    type="submit">
                    Agregar
                </b-button>
                </b-col>
                <b-col md="2">
                <b-button 
                    size="sm" 
                    variant="secondary"
                    @click="$router.go(-1)">
                    Regresar
                </b-button>
                </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row><!--/.row-->
  </div>
</template>

<script>
import axios from 'axios'
import { required, minLength, email } from 'vuelidate/lib/validators'
import Loader from '../Loader'

import { mapGetters } from "vuex";

export default {
  name: 'nuevoUsuario',
  components: {Loader},
  computed: {
    ...mapGetters([
      "httpURL",
      "sessionToken",
      "permisos",
      "role"
    ])
  },
  data: function () {
    return {
      titulo: this.$route.name,
      formulario:{
            codigo: '',
            nombre: '',
            paterno: '',
            materno: '',
            password: '',
            enviando: false
        }

    }
  },
  validations: {
        formulario:{
            codigo:{ required, minLength: minLength(4) },
            nombre:{ required, minLength: minLength(2) },
            paterno:{ required },
            materno:{ required }
        }
    },
  created(){ //Se verifica si tiene permiso
      if( this.role != 'administrador' && this.permisos.findIndex(x => x.numero === 101) < 0 )
        this.$router.go(-1);
  },
  methods: {
    agregarUsuario(){
      this.$v.$touch();
            if (this.$v.$invalid) {
                //this.formulario.enviando = false;
                //console.log('Inválido');
            } else {
                this.formulario.enviando = true;
                axios.post(this.httpURL+'/usuarios',{
                    codigo: this.formulario.codigo,
                    nombre: this.formulario.nombre,
                    paterno: this.formulario.paterno,
                    materno: this.formulario.materno
                },{headers: {token:this.sessionToken}})
                .then(res => {
                    this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                        text: 'Usuario agregado correctamente.' });
                    this.formulario.enviando = false;
                    this.$router.go(-1);
                })
                .catch(error => {
                    if(error.response){
                        //console.log(error.response);
                        this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                            text: error.response.data.mensaje });
                        this.formulario.enviando = false;
                    }else if( error.request){
                        this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                            text: 'No se pudo establecer una conexión al servidor.' });
                        this.formulario.enviando = false;
                    }
                });
            }
    }
  }
}
</script>

<style>
.text-error {
    color: #FFFFFF;
}
.invalid_input{
    border: 1px solid red;
}
.vue-notification {
  font-size: 14px;
}
</style>
